import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center gap-4 mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = { class: "w-full px-3 py-2 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white text-center cursor-pointer" }
const _hoisted_4 = ["accept"]
const _hoisted_5 = {
  key: 0,
  class: "text-red-500 mb-4"
}
const _hoisted_6 = { class: "flex justify-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.fileUploadVisible,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fileUploadVisible) = $event)),
    modal: "",
    header: "Subir archivo",
    style: { width: '35rem' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.askDescription)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "block mb-1" }, "Descripción", -1)),
              _createVNode(_component_InputText, {
                modelValue: _ctx.descripcion,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.descripcion) = $event)),
                maxlength: "20",
                placeholder: "Ingrese una descripción",
                class: "input-base bg-gray-50 input-success"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("label", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("i", { class: "pi pi-upload mr-2" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.fileName || 'BUSCAR ARCHIVO') + " ", 1),
          _createElementVNode("input", {
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBackgroundFileUpload && _ctx.handleBackgroundFileUpload(...args))),
            type: "file",
            class: "hidden",
            accept: _ctx.acceptedFileTypes
          }, null, 40, _hoisted_4)
        ])
      ]),
      (_ctx.uploadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.uploadError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fileUploadVisible = false)),
          class: "px-3 py-2 border border-red-500 text-red-500 rounded hover:bg-red-500 hover:text-white"
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "pi pi-times" }, null, -1),
          _createTextVNode(" CANCELAR ")
        ])),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleAccept && _ctx.handleAccept(...args))),
          class: "px-3 py-2 border border-blue-500 text-blue-500 rounded hover:bg-blue-500 hover:text-white cursor-pointer"
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("i", { class: "pi pi-check" }, null, -1),
          _createTextVNode(" ACEPTAR ")
        ]))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}